import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Offerings from './pages/Offerings';
import Facility from './pages/Facility';
import Gallery from './pages/Gallery';
import Faculty from './pages/Faculty';
import TC from './pages/TC';
import Contact from './pages/Contact';
import Disclosures from './pages/Disclosures';
import Admin from './pages/Admin';
import ActivityDetail from './pages/ActivityDetail';
import PreSchool from './pages/PreSchool';
// import NurseryTeacherTraining from './pages/NurseryTeacherTraining';
import Calendar from './pages/Calendar';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/offerings" element={<Offerings />} />
          <Route path="/facility" element={<Facility />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/faculty" element={<Faculty />} />
          <Route path="/tc" element={<TC />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/disclosures" element={<Disclosures />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/activities/:slug" element={<ActivityDetail />} />
          <Route path="/preschool" element={<PreSchool />} />
          {/* <Route path="/nursery-teacher-training" element={<NurseryTeacherTraining />} /> */}
          <Route path="/calendar" element={<Calendar />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

